export class Conflict extends Error {
  constructor() {
    super('Conflict');
    this.name = 'conflict';
  }
}
